"use client";

import * as React from "react";
import { Play, Podcast, ListMusic, ArrowRight, Volume2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const podcastEpisodes = [{
  id: 1,
  title: "Data-Driven Advocacy in 2024",
  duration: "45:20",
  date: "Oct 12, 2023",
  isPlaying: true
}, {
  id: 2,
  title: "Understanding Local Governance Structures",
  duration: "38:15",
  date: "Oct 05, 2023",
  isPlaying: false
}, {
  id: 3,
  title: "The Power of Community Outreach",
  duration: "52:10",
  date: "Sep 28, 2023",
  isPlaying: false
}, {
  id: 4,
  title: "Responsive Government Metrics",
  duration: "41:05",
  date: "Sep 21, 2023",
  isPlaying: false
}, {
  id: 5,
  title: "Civic Engagement in the Digital Age",
  duration: "48:30",
  date: "Sep 14, 2023",
  isPlaying: false
}];
export default function MediaLinks() {
  return;
}